// Analytics tracking utility
let sessionId = null;

// Generate or retrieve session ID
const getSessionId = () => {
  if (sessionId) return sessionId;
  
  // Check if session ID exists in sessionStorage
  sessionId = sessionStorage.getItem('analytics_session_id');
  
  if (!sessionId) {
    // Generate new session ID
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('analytics_session_id', sessionId);
  }
  
  return sessionId;
};

// List of public pages (pages that should be tracked)
const publicPages = [
  '/',
  '/services',
  '/about',
  '/gallery',
  '/contact',
  '/our-team',
  '/our-hours',
  '/specialty-services',
  '/urgent-care',
  '/review-us',
  '/message-us',
  '/urgent-care-booking',
  '/dog-dental-care',
  '/cat-dental-care',
  '/dog-skin-care',
  '/dog-eye-care',
  '/dog-vaccinations',
  '/dog-wellness-exams',
  '/dog-diet-nutrition',
  '/dog-surgeries',
  '/cat-diagnostic-imaging',
  '/cat-vaccinations',
  '/ultrasound-exams',
  '/pet-vaccinations',
  '/preventive-pet-care',
  '/veterinary-diagnostic-services',
  '/pet-dermatology-allergy-care',
  '/digital-veterinary-x-rays',
  '/dental-cleanings',
  '/pet-tooth-extraction',
  '/pet-ocular-services',
  '/pet-microchipping',
  '/pet-insurance-payments',
  '/pet-travel-certificates',
  '/on-site-pharmacy',
  '/end-of-life-care',
  '/pet-spay-neuter',
  '/pet-bladder-stone-removal',
  '/blocked-cats-urgent-care',
  '/foreign-body-surgery',
  '/soft-tissue-surgeries',
];

// Check if user is logged in
const isUserLoggedIn = () => {
  return !!(localStorage.getItem('token') || sessionStorage.getItem('token'));
};

// Check if page is public
const isPublicPage = (pathname) => {
  return publicPages.includes(pathname) || publicPages.some(page => pathname.startsWith(page));
};

// Track page view
export const trackPageView = async (pageUrl, pageTitle) => {
  try {
    // Don't track if user is logged in
    if (isUserLoggedIn()) {
      return;
    }
    
    // Don't track if not a public page
    if (!isPublicPage(pageUrl)) {
      return;
    }
    
    const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 
      (window.location.origin.includes("localhost") 
        ? "http://localhost:8000" 
        : window.location.origin + "/pandvah-backend");
    
    await fetch(`${API_BASE_URL}/api/analytics/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        page_url: pageUrl || window.location.pathname,
        page_title: pageTitle || document.title,
        referrer: document.referrer,
        session_id: getSessionId(),
      }),
    });
  } catch (error) {
    // Silent fail - don't disrupt user experience
  }
};
